/**
 * @generated SignedSource<<f5e4f79eb2cb6e3a860c1aebc5066168>>
 * @relayHash fe35d4047b80d75e20865be007294590
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID fe35d4047b80d75e20865be007294590

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "HomeMessage",
    "kind": "LinkedField",
    "name": "homemessage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "display",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "length",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomeMessageQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HomeMessageQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "fe35d4047b80d75e20865be007294590",
    "metadata": {},
    "name": "HomeMessageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "58d4c92e934a4eb9dca13377cc84b574";

export default node;
